<div class="card-body"> 
    <h3 class="text-white"> Thank you for requesting a quotation from Insure My Alpaca. Please confirm:</h3>
    <div class="form-group bg-white p-3 text-green" *ngFor="let ques of agreedQuestions;">
        {{ques.text}}
    </div>
    
    <div class="form-group mt-2">
        <button (click)="agreedBtnAction()" class="btn btn-success btn-sm">Agree</button>
    </div>
</div>